// import React from "react";
// import "../../cssfiles/homepage.css";

// export default function CustomLabel({
//   htmlFor,
//   labelText,
//   fontSize,
//   color,
//   width,
//   fontWeight,
// }) {
//   return (
//     <label
//       className="config-label"
//       htmlFor={htmlFor}
//       style={{
//         fontSize: fontSize ? `${fontSize}px` : "16px",
//         fontWeight: fontWeight ? fontWeight : 400,
//         color: color ? `${color}` : "var(--GreyVariation_4)",
//         width: width ? width : "auto",
//       }}
//     >
//       {labelText}
//     </label>
//   );
// }


import React from "react";
import "../../cssfiles/homepage.css";

export default function CustomLabel({ htmlFor, labelText, fontSize, color, width,fontWeight}) {
    return (
        <label className="config-label" htmlFor={htmlFor} style={{ fontSize: fontSize ? `${fontSize}px` : '16px',fontWeight: fontWeight ? fontWeight : 400, color: color ? `${color}` : 'var(--GreyVariation_4)', width: width? width:'auto'}}>
            {labelText}
        </label>
    )
}

